const Profile = {

    // FIELDS
    "fname": "First Name",
    "lname": "Last Name",
    "gender": "Gender",
    "dob": "Date of Birth",
    "mobile": "Mobile Number",
    "email": "Email",
    "profile": "Profile Photo",
    "district": "District",
    "address": "Address",

    "old_password": "Old Password",
    "new_password": "New Password",
    "confirm_password": "Confirm Password",

    // PAGE HEADER
    "profile": "Profile",
    "password": "Password",
    "change_password": "Change Password",

    // TOAST
    "success_changed": "Changed Successfully",

    // ERROR
    "error_fname": "Enter First Name",
    "error_lname": "Enter Last Name",
    "error_gender": "Select Gender",
    "error_dob": "Choose Date of Birth",
    "error_mobile": "Enter Mobile Number",
    "error_invalid_mobile": "Invalid Mobile Number",
    "error_email": "Enter Email",
    "error_profile": "Choose Profile Photo",
    "error_district": "Select District",
    "error_address": "Enter Address",

    "error_old_password": "Enter Old Password",
    "error_new_password": "Enter New Password",
    "error_confirm_password": "Enter Confirm Password",
    "error_password_match": "Confirm Password doesn't match",

}

export default Profile;